import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Petrol-index-1992f2b7e5368a99c-1'),
    routerUrl: '/Petrol',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Petrol')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Petrol-index-1992f2b7e5368a99c-2'),
        routerUrl: '/PetrolForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./PetrolForm')),
      },
      //$MORE$
    ],
  },
];
